var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32","width":"32","height":"32"}},[_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M24 18l-8-8-8 8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }